var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bubble",class:_vm.visible ? 'visible-transition scale transition-delay-'+_vm.delay+' '+_vm.cssClass+'' : 'invisible-transition scale '+_vm.cssClass+''},[_c('div',[_c('h6',[_vm._v(_vm._s(_vm.title)),_c('span',{staticClass:"bubble-value"},[_vm._v(_vm._s(_vm.value))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12a5b016","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Bubble.vue
// module id = null
// module chunks = 